import { render, staticRenderFns } from "./AskAnswerStream.vue?vue&type=template&id=57e3eaa2&scoped=true&"
import script from "./AskAnswerStream.vue?vue&type=script&lang=js&"
export * from "./AskAnswerStream.vue?vue&type=script&lang=js&"
import style0 from "./AskAnswerStream.vue?vue&type=style&index=0&id=57e3eaa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e3eaa2",
  null
  
)

export default component.exports